import apiClient from "services/axios";

const API = {
  detail: "/api/v1/monitoring-display-profiles",
};

export const detail = async (id, filter) => {
  const response = await apiClient.get(`${API.detail}/${id}`, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};
